(function () {
  const initProductAccordion = () => {
        $(".ps-artist-toggle").each(function () {
      if (this.dataset.defaultInitialized) return;
      this.dataset.defaultInitialized = "true";
      const expanded = window.matchMedia("(min-width: 750px)").matches;
      $(this).toggleClass("active", expanded);
      this.setAttribute("aria-expanded", String(expanded));
      $(this).siblings(".ps-artist-bio").toggle(expanded);
    });
$('.about__accordion-title').off('click.printedAbout').on('click.printedAbout', function () {
            // Artist information uses the same accordion behavior at every screen size.
      const section = $(this).closest('.about');
      const content = $(this).siblings('.about__accordion-description').first();
      if (!$(this).hasClass('active')) {
              // Keep other information dropdowns open.
        $(this).addClass('active');
        content.stop().slideDown(300);
      } else {
        $(this).removeClass('active');
        content.stop().slideUp(300);
      }
      section.find('.ps-artist-toggle').each(function () {
        this.setAttribute('aria-expanded', String(this.classList.contains('active')));
      });
    });
  };
  document.addEventListener('shopify:section:load', initProductAccordion);
  initProductAccordion();
})();
